import { useTranslation } from "react-i18next";
import Page from "app/shared/UI/Layout/Page";
import ActivityLogPageContent from "./ActivityLogPageContent";
import ActivityLogFilters from "./ActivityLogFilters";
import { ActivityLogProvider } from "app/services/activityLogContext";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFnsV3";

const ActivityLogPage = (props) => {
  const { t } = useTranslation();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ActivityLogProvider>
        <Page
          hasDrawer={true}
          drawerComponent={ActivityLogFilters}
          pageTitle={t("pageTitle.activityLog")}
          hasBackButton={false}
          contentComponent={ActivityLogPageContent}
          isDrawerOpen={true}
          {...props}
        />
      </ActivityLogProvider>
    </LocalizationProvider>
  );
};

export default ActivityLogPage;
